import script from "./WorkflowBio.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowBio.vue?vue&type=script&setup=true&lang=ts"

import "./WorkflowBio.vue?vue&type=style&index=0&id=02875c0c&lang=scss"

const __exports__ = script;

export default __exports__